import { z } from "zod";
import { schemes } from "../../schema-validation";
import { common } from "./common";

export const usageSchema = z.object({
  employeeID: schemes.mongoObjectId(),
  correction: z.boolean().optional().default(false),
  start_date: schemes.isoDate(),
  end_date: schemes.isoDate(),
  amount: z.number(),
  employeeCheckID: z.string().optional(),
});

export const usage = z
  .object({
    employees: z.array(usageSchema),
  })
  .merge(common);

export type Usage = z.infer<typeof usage>;
type UsageDocument = z.infer<typeof usageSchema> & {
  policyID: string;
  companyID: string;
  reportingPeriodID: string;
};

export type UsageUpdate = {
  insertOne: {
    document: UsageDocument;
  };
}[];
